module.exports = __webpack_public_path__ + "static/media/targeting.0ad9f3e7.png";